import React from "react";
import { Card } from "@/components/ui/card";
import { Sun, Moon, Monitor, Palette } from "lucide-react";
import { useTheme } from "@/context/ThemeContext";

const OPTIONS = [
  { key: "light", label: "Light", icon: Sun },
  { key: "dark", label: "Dark", icon: Moon },
  { key: "system", label: "System", icon: Monitor },
];

export default function AppearanceCard() {
  const { preference, setTheme } = useTheme();
  return (
    <Card className="rounded-3xl border-slate-100 bg-white p-6 shadow-sm dark:border-white/[0.07] dark:bg-[#141820]" data-testid="settings-appearance-card">
      <div className="mb-2 flex items-center gap-2">
        <Palette className="h-5 w-5 text-slate-400 dark:text-slate-500" />
        <h2 className="font-heading text-lg font-bold text-slate-900 dark:text-slate-100">Appearance</h2>
      </div>
      <p className="mb-5 text-sm text-slate-500 dark:text-slate-400">Choose how Yaprio looks on your device. System follows your device setting.</p>
      <div className="grid grid-cols-1 gap-3 sm:grid-cols-3">
        {OPTIONS.map(({ key, label, icon: Icon }) => {
          const active = preference === key;
          return (
            <button
              key={key}
              onClick={() => setTheme(key)}
              data-testid={`theme-${key}`}
              className={`group flex items-center gap-3 rounded-2xl border p-4 text-left transition-all sm:flex-col sm:justify-center sm:text-center ${
                active
                  ? "border-pink-400 bg-pink-50 text-pink-600 shadow-sm dark:border-pink-400/70 dark:bg-pink-500/[0.10] dark:text-pink-300"
                  : "border-slate-100 bg-slate-50/60 text-slate-600 hover:border-slate-200 hover:bg-white dark:border-white/[0.07] dark:bg-white/[0.025] dark:text-slate-300 dark:hover:border-white/10 dark:hover:bg-white/[0.05]"
              }`}
              aria-pressed={active}
            >
              <span className={`flex h-10 w-10 items-center justify-center rounded-xl ${active ? "bg-white/70 dark:bg-pink-400/10" : "bg-white dark:bg-white/[0.05]"}`}><Icon className="h-5 w-5" /></span>
              <span className="font-semibold">{label}</span>
            </button>
          );
        })}
      </div>
    </Card>
  );
}
